<template>
  <div class="breadcrumbs">
    <span v-for="folder in folders">
      <span v-if="folder.link"><a href="#" @click.prevent="fetchDirectoryContents(folder.path)">{{ maybeFindReplaceCaret(folder.name) }}</a> / </span>
      <span v-else>{{ maybeFindReplaceCaret(folder.name) }} / </span>
    </span>
    <span v-if="isSuperAdmin" style="margin-left: 5px; cursor: copy;" @click="copyDirectoryPath"><i class="nc-icon nc-single-copy-04"></i></span>
  </div>
</template>

<script>
  import {notifySuccess} from '@/utilities/utils'
  import Constants from '@/utilities/constants'

  export default {
    props: ['path'],
    computed: {
      isSuperAdmin() {
        return this.$store.get('security/isInGroup', Constants.GROUPS.SUPER_USERS)
      },
      folders() {
        let localPath = this.path
        if (localPath.startsWith('/')) {
          localPath = localPath.substr(1, localPath.length)
        }

        const folderNames = localPath.split('/')

        const folders = []
        let path = ''
        for (let i = 0; i < folderNames.length; i++) {
          let folderName = folderNames[i]
          path += '/' + folderName
          const folder = {
            name: folderName,
            path: path,
            link: true
          }

          // don't link the first or the last folder
          if (i === 0 || i === folderNames.length - 1) {
            folder.link = false
          }

          folders.push(folder)
        }

        return folders
      }
    },
    data () {
      return {
        localPath: null
      }
    },
    methods: {
      fetchDirectoryContents(path) {
        this.$emit('click', path)
        this.$store.dispatch('files/fetchDirectoryContents', path)
      },
      copyDirectoryPath() {
        const lastFolder = this.folders[this.folders.length - 1]

        navigator.clipboard.writeText(lastFolder.path);

        notifySuccess(this, `Copied path: '${lastFolder.path}' to your clipboard`)
      },
      maybeFindReplaceCaret(path) {
        return path.replace(/\^/g, '/')
      }
    },
    mounted() {
      this.localPath = this.path
    }
  }
</script>
